import HBMessage from "@/components/HBMessage";

export const isWhiteListRedirectUrl = (url) => {
  // 白名单：美素、稿定、花瓣、127.0.0.1（花瓣Pro）、（稿定Pro自定义协议）
  const regExp = /meisupic|meisubq|gaoding|focodesign|huaban\.com/i;

  if (regExp.test(url)) {
    return true;
  }

  // 相对地址
  if (url.startsWith("/")) {
    return true;
  }
};

const safeRedirectUrl = (url) => {
  const urlPatten = /^(?:(http|https):)?\/\/[^ "]+$/;
  const pathPatten = /^\//;

  if (urlPatten.test(url) || pathPatten.test(url)) {
    if (isWhiteListRedirectUrl(url)) {
      window.location.href = url;
    } else {
      HBMessage.error("重定向链接不在白名单内");
    }
  } else {
    HBMessage.error("链接有误");
  }
};

export default safeRedirectUrl;
